export const hobbiesColor = '#43e543';

export const hobbiesHeading = 'Hobbies';

export const hobbiesDescription =
  'During my downtime, I enjoy investing in personal growth, whether by challenging my mind or nurturing my body. Other times, I let go, immersing myself in captivating topics or exploring imaginative worlds.';

export const hobbyItems = [
  {
    title: 'Reading',
    iconKey: 'reading',
    link: 'https://fable.co/quinton-140484463229',
    descriptions: [
      "Since 2023, I've been somewhat getting back into reading, mostly random non-fiction topics that had interesting titles/topics, as well as a few fiction stories/books.",
      "Click on the icon to see what I'm reading.",
    ],
  },
  {
    title: 'LeetCode',
    iconKey: 'leetcode',
    link: 'https://leetcode.com/u/BossNass/',
    descriptions: [
      'In the Summer of 2024, to keep my problem-solving skills fresh, I decided I would attempt to do more LeetCode questions.',
      'Click on the icon to see my progress.',
    ],
  },
  {
    title: 'Lego Creations',
    iconKey: 'lego',
    descriptions: [
      "Since a young age, I've been building Lego, and that hobby has not stopped.",
      'Coming soon',
    ],
  },
  {
    title: 'Movies',
    iconKey: 'movies',
    link: 'https://letterboxd.com/BossNassTheKing/',
    descriptions: [
      "In March of 2024, I decided to attempt to make note of every movie I've watched as well as give it my personal rating.",
      'Click the icon to see my Letterboxd profile.',
    ],
  },
  {
    title: 'Sports',
    iconKey: 'sports',
    descriptions: [
      'I like to get out and get active when the weather is nice. Volleyball and basketball are my go-to.',
      '',
    ],
  },
];
